<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-analysis"></span> 周边销售排行
            </span>
            <router-link v-if="$utils.have('/sales/goods/goods_list') && intervalData" class="fr color-theme" :to="`/report/sales/surrounding?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">
                查看详情<span class="el-icon-right"></span>
            </router-link>
        </div>
        <div v-if="data" class="content">
            <el-tabs v-model="activeName"  @tab-click="clickTab">
                <el-tab-pane label="全部类别" name="-1"></el-tab-pane>
                <el-tab-pane label="唱片专辑" name="1"></el-tab-pane>
                <el-tab-pane label="服饰" name="2"></el-tab-pane>
                <el-tab-pane label="纪念品" name="3"></el-tab-pane>
                <el-tab-pane label="服饰" name="5"></el-tab-pane>
                <el-tab-pane label="其他" name="4"></el-tab-pane>
            </el-tabs>
            <el-row :gutter="20">
                <el-col :sm="12" :md="8">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <div class="group-title">
                                商品销售额
                            </div>
                        </div>
                        <div class="rank">
                            <div v-for="(item,index) in data.amountRankList" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                                <div class="info">
                                    <el-tooltip class="title" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{item.goodsName}}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{item.amount}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="data.amountRankList.length < 1" class="no-data">暂无数据</div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="8">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <div class="group-title">
                                商品数
                            </div>
                        </div>
                        <div class="rank">
                            <div v-for="(item,index) in data.goodsNumRankList" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                                <div class="info">
                                    <el-tooltip class="title" :content="item.goodsName" placement="top">
                                        <span class="ellipsis">{{item.goodsName}}</span>
                                    </el-tooltip>
                                    <div class="amount">商品数: {{item.goodsNum}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="data.goodsNumRankList.length < 1" class="no-data">暂无数据</div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </el-card>
</template>

<script>
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            activeName: "-1"
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/goodsdata/rank",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                    goodsCategory: this.activeName
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result || null;
                    } else {
                        this.data = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.data = null;
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.getData();
        },
    }
}
</script>

<style lang="scss" scoped>
.content{
    .rank{
        .item{
            overflow: hidden;
            margin: 20px 0;
            .num{
                width: 32px;
                height: 32px;
                line-height: 32px;
                border-radius: 50%;
                background-color: #f8f8f8;
                text-align: center;
                margin-right: 10px;
                float: left;
                font-size: 15px;
                font-weight: 700;
                &.top-num-0{
                    background-color: $--color-danger;
                    color: #fff;
                }
                &.top-num-1{
                    background-color: $--color-warning;
                    color: #fff;
                }
                &.top-num-2{
                    background-color: $--color-info;
                    color: #fff;
                }
            }
            .info{
                overflow: hidden;
                .title{
                    font-size: 14px;
                }
                .amount{
                    color: $--color-info;
                }
            }
        }
    }

    .no-data{
        color: #000;
        font-size: 20px;
    }
}

</style>